import {NgModule} from '@angular/core';
import {CoreTeamSectionComponent} from './core-team-section.component';

@NgModule({
    declarations: [CoreTeamSectionComponent],
    exports: [CoreTeamSectionComponent]
})
export class CoreTeamSectionModule {
}